import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createBlock as _createBlock } from "vue";
import _imports_0 from '../../assets/VouchersEmptyState.png';
import _imports_1 from '../../assets/arrow-right.png';
const _hoisted_1 = ["href"];
const _hoisted_2 = { key: 0 };
const _hoisted_3 = {
    key: 1,
    class: "account-summary-button"
};
const _hoisted_4 = { class: "nowrap bold" };
const _hoisted_5 = ["src"];
const _hoisted_6 = { class: "dateTimeLabel nowrap" };
const _hoisted_7 = { class: "providerLabel nowrap" };
const _hoisted_8 = { class: "voucherCountLabel nowrap" };
const _hoisted_9 = { class: "balanceLabel nowrap" };
import { useRouter } from 'vue-router';
export default /*@__PURE__*/ _defineComponent({
    __name: 'AccountButton',
    props: {
        title: {},
        icon: {},
        provider: {},
        balance: {},
        circleIcon: { type: Boolean },
        isAddButton: { type: Boolean },
        href: {},
        empty: { type: Boolean },
        showProvider: { type: Boolean, default: true },
        showBalance: { type: Boolean, default: true },
        voucherCount: { default: 0 },
        dateTime: {}
    },
    setup(__props) {
        const props = __props;
        const router = useRouter();
        function getIconStyle() {
            if (props.circleIcon) {
                return null;
            }
            else {
                return {
                    width: '72px',
                    height: '48px',
                    borderRadius: '5px'
                };
            }
        }
        return (_ctx, _cache) => {
            const _component_v_col = _resolveComponent("v-col");
            const _component_v_row = _resolveComponent("v-row");
            return (_openBlock(), _createElementBlock("a", {
                href: _ctx.href != null ? _ctx.href : _unref(router).currentRoute.value.path,
                style: _normalizeStyle(_ctx.empty ? 'opacity: 0.7' : '')
            }, [
                (_ctx.isAddButton)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                        _createVNode(_component_v_row, null, {
                            default: _withCtx(() => [
                                _createVNode(_component_v_col, null, {
                                    default: _withCtx(() => _cache[0] || (_cache[0] = [
                                        _createElementVNode("img", {
                                            class: "plusIcon",
                                            src: _imports_0
                                        }, null, -1)
                                    ])),
                                    _: 1
                                })
                            ]),
                            _: 1
                        })
                    ]))
                    : _createCommentVNode("", true),
                (!_ctx.isAddButton)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                        _createVNode(_component_v_row, null, {
                            default: _withCtx(() => [
                                _createVNode(_component_v_col, { class: "title-col" }, {
                                    default: _withCtx(() => [
                                        _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.title), 1)
                                    ]),
                                    _: 1
                                })
                            ]),
                            _: 1
                        }),
                        _createVNode(_component_v_row, null, {
                            default: _withCtx(() => [
                                _createVNode(_component_v_col, null, {
                                    default: _withCtx(() => [
                                        _createElementVNode("img", {
                                            class: "icon",
                                            src: _ctx.icon,
                                            style: _normalizeStyle(getIconStyle())
                                        }, null, 12, _hoisted_5)
                                    ]),
                                    _: 1
                                })
                            ]),
                            _: 1
                        }),
                        (_ctx.dateTime)
                            ? (_openBlock(), _createBlock(_component_v_row, {
                                key: 0,
                                class: "mt-0"
                            }, {
                                default: _withCtx(() => [
                                    _createVNode(_component_v_col, null, {
                                        default: _withCtx(() => [
                                            _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.dateTime), 1)
                                        ]),
                                        _: 1
                                    })
                                ]),
                                _: 1
                            }))
                            : _createCommentVNode("", true),
                        (_ctx.showProvider)
                            ? (_openBlock(), _createBlock(_component_v_row, {
                                key: 1,
                                class: "mt-0"
                            }, {
                                default: _withCtx(() => [
                                    _createVNode(_component_v_col, null, {
                                        default: _withCtx(() => [
                                            _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.provider || '\u00A0'), 1)
                                        ]),
                                        _: 1
                                    })
                                ]),
                                _: 1
                            }))
                            : _createCommentVNode("", true),
                        (_ctx.voucherCount > 0)
                            ? (_openBlock(), _createBlock(_component_v_row, { key: 2 }, {
                                default: _withCtx(() => [
                                    (_ctx.voucherCount > 1)
                                        ? (_openBlock(), _createBlock(_component_v_col, { key: 0 }, {
                                            default: _withCtx(() => [
                                                _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.voucherCount) + " Vouchers", 1)
                                            ]),
                                            _: 1
                                        }))
                                        : (_openBlock(), _createBlock(_component_v_col, { key: 1 }, {
                                            default: _withCtx(() => _cache[1] || (_cache[1] = [
                                                _createElementVNode("span", { class: "voucherCountLabel nowrap" }, "Voucher", -1)
                                            ])),
                                            _: 1
                                        }))
                                ]),
                                _: 1
                            }))
                            : _createCommentVNode("", true),
                        (_ctx.showBalance)
                            ? (_openBlock(), _createBlock(_component_v_row, {
                                key: 3,
                                class: "mt-0"
                            }, {
                                default: _withCtx(() => [
                                    _createVNode(_component_v_col, { class: "v-col-7 balanceCol" }, {
                                        default: _withCtx(() => [
                                            _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.balance), 1)
                                        ]),
                                        _: 1
                                    }),
                                    _createVNode(_component_v_col, { class: "arrow-col" }, {
                                        default: _withCtx(() => _cache[2] || (_cache[2] = [
                                            _createElementVNode("img", {
                                                class: "arrow",
                                                src: _imports_1
                                            }, null, -1)
                                        ])),
                                        _: 1
                                    })
                                ]),
                                _: 1
                            }))
                            : _createCommentVNode("", true)
                    ]))
                    : _createCommentVNode("", true)
            ], 12, _hoisted_1));
        };
    }
});
